

import path from 'path'
import fs from 'fs'
import yargs from 'yargs'
import server from './server'
import debug from 'debug'

const argv = yargs
  .usage('Usage: $0 <path> [options]')

  .command('path', 'Directory to serve')

  .alias('p', 'port')
  .default('port', process.env.PORT || 8080, '$PORT or 8080')
  .describe('port', 'Port to listen on')

  .alias('C', 'cert')
  .default('cert', 'cert.pem')
  .describe('cert', 'Path to ssl cert file')

  .alias('K', 'key')
  .default('key', 'key.pem')
  .describe('key', 'Path to ssl key file')

  .alias('I', 'index')
  .default('index', 'index.html')
  .describe('index', 'HTML fallback for single page apps')

  .alias('s', 'silent')
  .boolean('silent')
  .default('silent', false)
  .describe('silent', 'Suppress log messages from output')

  .boolean('cors')
  .default('cors', false)
  .describe('cors', 'Set `Access-Control-Allow-Origin`')

  .default('max', 100)
  .describe('max', 'Limit the number of pushed dependencies')

  .alias('h', 'help')
  .help('help')

  .argv

if (!argv.silent) debug.enable('http2server')
const log = debug('http2server')

function directoryExists (path) {
  try {
    const stats = fs.statSync(path)
    return stats.isDirectory()
  } catch (err) {}
}

const publicDirectory = path.join(process.cwd(), 'public')
argv.root = typeof argv._[0] !== 'undefined' ? path.resolve(argv._[0])
  : directoryExists(publicDirectory) ? publicDirectory
  : process.cwd()

argv.index = path.resolve(argv.root, argv.index)

const app = server(argv)
app.listen(argv.port)
log(`Serving ${argv.root} on port ${argv.port}`)
